import { Component, OnInit, NgZone, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { CodebarReaderService, Package, AuthenticationService, Ticket } from 'wms-lib';
import { PackingListsComponent } from '../../../../shared/components/base-components/packing-lists.component';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { TicketDetailsComponent } from '../../../../help-desk/components/tickets/ticket-details/ticket-details.component';

@Component({
    selector: 'app-search-packing-lists',
    templateUrl: './search-packing-lists.component.html',
    styleUrls: ['../../../../shared/components/base-components/packing-lists.component.scss']
})
export class SearchPackingListsComponent extends PackingListsComponent implements OnInit {
    @Input() package: Package;
    constructor(store: Store,private router: Router, codebar_service: CodebarReaderService,ng_zone: NgZone,
                authenticationService: AuthenticationService, private dialogService: DialogService) {
        super(store, codebar_service, ng_zone, authenticationService);
    }

  viewDetails(ticket: Ticket) {
    this.dialogService.open(TicketDetailsComponent,{ data: {ticket: ticket},  width: '70%'});
  }

  cardTitle(ticket: Ticket):String {
    return `#${ticket.id} ${ticket.ticket_type.name}`;
  }

  cardClientName(ticket: Ticket): String {
    return ticket.client ? ticket.client.name : '';
  }

  cardDescription(ticket: Ticket): String {
    return ticket.description;
  }

  cardCreatedBy(ticket: Ticket): string {
    return `Created by: ${ticket.created_by ? ticket.created_by.username: ''}`;
  }

  cardAssignTo(ticket: Ticket): string {
    return `Assign to: ${ticket.assign_to ? ticket.assign_to.username: ''}`;
  }

  cardClosedBy(ticket: Ticket): string {
    return `Closed by: ${ticket.closed_by ? ticket.closed_by.username: ''}`;
  }

  cardFullAuthors(ticket: Ticket): string {
    let msg = this.cardCreatedBy(ticket) + '  ' + this.cardAssignTo(ticket);
    if (ticket.status_key == "C") msg += ' ' + this.cardClosedBy(ticket);
    return msg;
  }

  get MinSpan(): number {
    return 6;
  }

  get FreightSpan(): number {
    return +this.arrival.isFreight * 2;
  }

  get IncompleteSpan(): number {
    return +this.arrival.isIncomplete * 1;
  }
}
